import types from './types';

const setEateries = eateries => ({
  type: types.SET_EATERIES,
  payload: eateries,
});

const setStory = story => ({
  type: types.SET_STORY,
  payload: story,
});

const setIsSaving = isSaving => ({
  type: types.SET_IS_SAVING,
  payload: isSaving,
});

const setEditedSlug = editedSlug => ({
  type: types.SET_EDITED_SLUG,
  payload: editedSlug,
});

export default {
  setEateries,
  setStory,
  setIsSaving,
  setEditedSlug
};
